import React from 'react';
import { motion } from 'framer-motion';
import { CtaButton } from './CtaButton';
export function LegacySection() {
  return <section className="w-full bg-deep-blue" data-id="element-86" data-mp="3oag6qrbe6wwe">
      <div className="mx-auto max-w-3xl px-4 py-20 text-center md:py-28" data-id="element-87" data-mp="63ic1ez7m4lk">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.7
      }} className="font-display text-3xl font-bold leading-tight text-white md:text-[44px]" data-id="element-88" data-mp="64tdv993h2a1">
          Los juguetes se rompen. Las pantallas se apagan. La fe que siembres hoy
          los acompaña toda la vida.
        </motion.h2>

        <motion.p initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.7,
        delay: 0.15
      }} className="mx-auto mt-6 max-w-2xl text-[17px] leading-relaxed text-cream/85 md:text-lg" data-id="element-89" data-mp="juwunkp7g3s3">
          Dentro de veinte años no van a recordar cuántos juguetes les regalaste.
          Pero si hoy les pones en las manos la historia más grande jamás contada
          — en el idioma que ellos aman — puede que un día se la lean a sus
          propios hijos. Y ese sí es un regalo que no se termina.
        </motion.p>

        <div className="mt-10" data-id="element-90" data-mp="2t8ghqmj2fqez">
          <CtaButton label="EMPEZAR HOY" size="lg" onDark href="https://totaliadigital.com/cart/50437968429249:1" microcopy="Descarga inmediata · Garantía de 7 días · Acceso de por vida" data-id="element-91" data-mp="2t9hvwzvdot0x" />
        </div>
      </div>
    </section>;
}